import {
  Dispatch,
  MouseEvent as ReactMouseEvent,
  SetStateAction,
  useCallback,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from 'react'
  
  import {
    Grid,
    GridCellProps,
    GridColumn,
    GridPageChangeEvent,
    GridToolbar,
  } from '@progress/kendo-react-grid'

  import styles from '../../styles/apoiogestao/ApoioGestao.module.scss'
  import commonStyles from '../../styles/common/Common.module.scss'
  import {
  TabStrip,
  TabStripSelectEventArguments,
  TabStripTab,
} from '@progress/kendo-react-layout'
import SessionStorageService from '../../services/SessionStorageService'
import { faPrint } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, DropDownButton } from '@progress/kendo-react-buttons'
import { ComboBox } from '@progress/kendo-react-dropdowns'
import { Tooltip } from '@progress/kendo-react-tooltip'
import { format } from 'date-fns'
import { CSVLink } from 'react-csv'
import { options } from 'yargs'
import { PagerTargetEvent } from '@progress/kendo-react-data-tools'
import { ResultadoApoioGestaoDesconformidadeCommandGridCell } from './ResultadoApoioGestaoDesconformidadeCommandGridCell'
import clsx from 'clsx'
import { GetUserNameTecnico, b64toBlob, exportPDFWithMethod, get, handleDownload, handleGenericError, hasPermission, post, setCoordenadasPoligono, setDesconformidadeSelected, updateColumnsGrid } from '../../services/utils'
import { AG_DESCONFORMIDADE_POINT_NAME, CONSULTA_AG_DESCONFORMIDADE, CURRENT_TIMEZONE, GET_AG_DESCONFORMIDADE_BY_ID, GET_AG_DESCONFORMIDADE_SHAPEFILE, GET_DOCUMENTO, PERMISSION_APOIO_GESTAOPERFIL_INTERMEDIO_EDICAO, PERMISSION_APOIO_GESTAO_PERFIL_COMPLETO_EDICAO, PERMISSION_APOIO_GESTAO_PERFIL_TOTAL, PESQUISAR_DOCUMENTOS_BY_DESCONFORMIDADES_IDS, URL_AJUDA_APOIO_GESTAO_PRETENSAO, clearLayers } from '../../utils/constants'
import { useAgDesconformidadeStore } from '../../stores/agDesconformidade'

import { process } from '@progress/kendo-data-query';
import { ExcelExport } from '@progress/kendo-react-excel-export'
import { GridPDFExport } from '@progress/kendo-react-pdf'
import { useCommonStore } from '../../stores/common'
import MaximizeButton from '../common/MaximizeButton'
import VisualizadorColunas from '../Generico/VisualizadorColunas '
import { elementoClickMais, itemRenderMais, mostraFloatingMenu_e_Mapa, ocultaFloatingMenu_e_Mapa, telaMobile } from '../common/ItemRenderMais'
import ReactGA from 'react-ga4';
import { Dialog } from '@progress/kendo-react-dialogs'
import ImagePreviewV2 from '../viewer/ImagePreviewV2'
import { ResultadoDocumentoCommandGridCell } from '../documentos/ResultadoDocumentoCommandGridCell'
import moment from 'moment'
import "moment-timezone"
import { base64ApaImage, base64FooterImages, base64SiarlImage } from '../../routes/Base64Images'

type IProps = {
    onCloseClick: (
      e: ReactMouseEvent<HTMLButtonElement, MouseEvent>
    ) => void | undefined
    setShowResults: Dispatch<SetStateAction<boolean>>
    setShowRegistarDesconformidadeForm?: Dispatch<SetStateAction<boolean>>
  }
  
  type PageState = {
    skip: number
    take: number
  }
  
  const initialDataState: PageState = { skip: 0, take: 20 }
  
  type DesconformidadeResult =  {
    id: number;
   
  }
export default function  ResultadoApoioGestaoDesconformidade({
  onCloseClick,
  setShowRegistarDesconformidadeForm,
  setShowResults
}:IProps){
  const [isMobile, setIsMobile] = useState(false);
  const [selected, setSelected] = useState<number>(0)
  const [desconformidades, setDesconformidades] = useState<any[]>([])
  const [page, setPage] = useState<PageState>(initialDataState)
  const [documentos, setDocumentos] = useState([])
  const [urlDoDocumento, setUrlDoDocumento] = useState("");
  const [idDoDocumento, setIdDoDocumento] = useState("");
  const [openForm, setOpenForm] = useState<boolean>(false)
  const [showExportButtons, setShowExportButtons] = useState(true)
  const [dataStateDocumentos, setDataStateDocumentos] = useState({
    skip: 0,
    take: 20,
    sort: [],
    group: [],
  });
  const [pageSizeValue, setPageSizeValue] = useState<
    number | string | undefined
  >()
  const selectAgDesconformidadeResult = useAgDesconformidadeStore(
    (state) => state.selectAgDesconformidadeResult
  )

  const selectAgDesconformidadeResultId = useAgDesconformidadeStore(
    (state) => state.selectAgDesconformidadeResultId
  )

  const isCurrentViewMaximized = useCommonStore(state => state.isCurrentViewMaximized)

  const REGISTOS = 0;
  const DOCUMENTOS = 1;
  const handleSelect = (e: TabStripSelectEventArguments) => {
    setSelected(e.selected)
    if (e.selected == REGISTOS) {
      setShowExportButtons(true)
    } else if (e.selected == DOCUMENTOS) {
      setShowExportButtons(false)
    }
  }
  const handlePageChange = (event: GridPageChangeEvent) => {
    const targetEvent = event.targetEvent as PagerTargetEvent
    const take = event.page.take

    if (targetEvent.value) {
      setPageSizeValue(targetEvent.value)
    }

    setPage({
      ...event.page,
      take,
    })
  }
  const [dataState, setDataState] = useState({
    skip: 0,
    take: 20,
    sort: [],
    group: [],
  });


  useEffect(() => {
    
    ReactGA.send({ hitType: "pageview", page: "/ResultadoApoioAGestaoDesconformidade" });

  }, []);

  const getDesconformidade = async (data: any) =>
  await get<any, any>(`${GET_AG_DESCONFORMIDADE_BY_ID}/` + data)
  const getDocumentosByDesconformidadeIds = async(data: any) => await post<any,any>(`${PESQUISAR_DOCUMENTOS_BY_DESCONFORMIDADES_IDS}`, data);
  const getDocumento = async (data: any) =>
  await get<any, any>(`${GET_DOCUMENTO}/` + data)
  const getShapeFile = async (data: any) =>
  await post<any, any>(`${GET_AG_DESCONFORMIDADE_SHAPEFILE}`, data)
  
  const clearSearchResults = () => {
    SessionStorageService.removeItem('resultadoApoioGestaoDesconformidade')
    SessionStorageService.removeItem('lastSearchDesconformidade')
    setCoordenadasPoligono(undefined);
    const iframe: any = document.getElementById('iframeGeoPortal')
      iframe.contentWindow?.postMessage(
        { type: clearLayers["CLEAR_LAYERS_DESCONFORMIDADE"], value: 'true' },
        '*'
      )
      iframe.contentWindow?.postMessage(
        { type: 'SiarlRemoveSelection', value: 'true' },
        '*'
      )

      postMessage({ type: 'resultadoApoioGestaoPretensaoPesquisaChange' }, '*')
  }

  const selectDesconformidadeResultId = useAgDesconformidadeStore(
    (state) => state.selectAgDesconformidadeResultId
  )
  const selectDesconformidadeResult = useAgDesconformidadeStore(
    (state) => state.selectAgDesconformidadeResult
  )

  const consultarDesconformidade = async (data: any) =>
    await post<any, any>(`${CONSULTA_AG_DESCONFORMIDADE}`, data)

  const initialized = useRef(false)
    useEffect(() => {
        if (!initialized.current) {
          initialized.current = true;
if (SessionStorageService.getItem("lastSearchDesconformidade") && !SessionStorageService.getItem("firstCallAgDesconformidade")) {
      postMessage({ type: "showLoader" }, "*");
      const objToSearch = SessionStorageService.getItem("lastSearchDesconformidade") ?? '';
      consultarDesconformidade(objToSearch).then((data) => {
        SessionStorageService.setItem("resultadoApoioGestaoDesconformidade", JSON.stringify(data));
        setResultsDesconformidade();
        postMessage({ type: "hideLoader" }, "*");
      })
    } 
    else {
      setResultsDesconformidade();
  }
}
  }, [])
 
  const setResultsDesconformidade = () => {

    const desconformidadesStored = JSON.parse(
      SessionStorageService.getItem('resultadoApoioGestaoDesconformidade') ?? ''
    )
    setDesconformidades(desconformidadesStored)
    const ids: any[] = [];
    desconformidadesStored.forEach((item: any) => {
      ids.push(item.id);
    })
    const iframe: any = document.getElementById('iframeGeoPortal')

    iframe.contentWindow?.postMessage(
      { type: 'SiarlDefineExtraLayerTooltipColumns', value:
        { layer: AG_DESCONFORMIDADE_POINT_NAME,  columns: colums.columns.filter((x: { show: any }) => x.show).map((option: { field: any; title: any }) => ({
     field: option.field,
     title: option.title
   })) } },
      '*'
    )

    iframe.contentWindow?.postMessage(
      { type: 'SiarlDesconformidadeSearch', value:{ ids : ids, result:desconformidadesStored}  },
      '*'
    )

    postMessage({type: "showLoader"}, "*");
     const idsDocunentos = desconformidadesStored?.map((d: any) => d.id)
    getDocumentosByDesconformidadeIds(idsDocunentos).then(result => {
      setDocumentos(result);
    }).catch((err)=>{
      console.log({err})
    }).finally(()=>{
      postMessage({type: "hideLoader"}, "*");
    })

  }

  

  useEffect(() => {
    const iframe: any = document.getElementById('iframeGeoPortal')
    const ids: number[] = []
    desconformidades.forEach((element: any) => {
      ids.push(element.id)
    })
    iframe.contentWindow?.postMessage(
      { type: 'SiarlDesconformidadeSearch', value: ids },
      '*'
    )
  }, [])

  const handleInfoClickById = (desconformidadeLine: any) => async () => {
    try {
      const desconformidade = await getDesconformidade(desconformidadeLine.id);
      const tecnico = await GetUserNameTecnico(desconformidade.utilizador_id);

     if (!desconformidade) {
      postMessage({type: "infoMsg", value: { message: "Registo desativado" }}, "*");
      return;
    }
    SessionStorageService.setItem("novaDesconformidade", 'false');
    SessionStorageService.setItem("NovoRegistoDesconformidade", "false");
    postMessage({type: "showLoader"}, "*");
    
    
    const agDesconformidadeObject = {
      ...desconformidade,
      id: desconformidade?.id ?? undefined,
      num_processo_file_doc: desconformidade?.num_processo_file_doc ?? undefined,
      tecnicoRegisto: tecnico,
      estado_id: desconformidade?.estado ?? undefined,
      medida_corretiva_a_aplicar: desconformidade?.medida_corretiva_a_aplicar ?? undefined,
      medida_corretiva_aplicada: desconformidade?.medida_corretiva_aplicada ?? undefined,
      local: desconformidade?.local ?? undefined,
      data_registo: desconformidade.data_registo ? moment.utc(desconformidade.data_registo).tz(CURRENT_TIMEZONE) : undefined,
      decisao: desconformidade.decisao ?? undefined,
      data_resolucao: desconformidade?.data_resolucao? new Date(desconformidade?.data_resolucao):null,
      observacoes: desconformidade.observacoes ?? undefined,
      tecnico_analise : desconformidade.userAnalise


    }

    selectDesconformidadeResultId(desconformidade.id)
    selectDesconformidadeResult(agDesconformidadeObject)
    setDesconformidadeSelected(agDesconformidadeObject);
    
    const iframe: any = document.getElementById('iframeGeoPortal')
    iframe.contentWindow?.postMessage(
      { type: 'SiarlDesconformidadeSearch', value: [desconformidade.id] },
      '*'
    )
    iframe.contentWindow?.postMessage(
      { type: 'SiarlDesconformidadeCenter', value: [desconformidade.id] },
      '*'
    )
    setShowResults(false)
    if (setShowRegistarDesconformidadeForm) setShowRegistarDesconformidadeForm(true)
    } catch (error) {
      handleGenericError(error);
      console.error({error})
    }finally{

      postMessage({type: "hideLoader"}, "*");

    }
  
  }

  const CommandCell = (props: GridCellProps) => (
    <ResultadoApoioGestaoDesconformidadeCommandGridCell
      {...props}
      onDetailsClick={handleInfoClickById}
      onOpentitle={handleInfoClickById}
      onMapCenter={mapCenter}
      onOpenPdfReport={handleInfoClickById}
    />
  )

  const mapCenter = (item: Record<string, any>) => async () => {
    const iframe: any = document.getElementById('iframeGeoPortal');
    const id = item.desconformidade_id ?? item.id;
    iframe.contentWindow?.postMessage(
      { type: 'SiarlDesconformidadeCenter', value: [item.id] },
      '*'
    )
   }

  const dataStateChange = (event: any) => {
    setDataResult(process(desconformidades, event.dataState));
    setDataState(event.dataState);
  };

  const [dataResult, setDataResult] = useState(
    process(desconformidades, dataState)
  );

  const itemRender = (props: { item: any; itemIndex: number }) => {
    const isTitleItem = props.item.key === 'titulo';
    if (isTitleItem) {
      // Item de título personalizado
      return (
        <div className={styles.DropDownButtonTitulo}>
          <span>{props.item.text}</span>
        </div>
      );
    } else {
      // Demais itens
      return (
        <div className={styles.DropDownButtonItem}>
          <span>{props.item.text}</span>
        </div>
      );
    }
  };


  const optionsExportar = [
    {
      key: 'ExportarListaResultadosExcel',
      text: 'Excel',
    },
      // {
      //   key: 'ExportarListaResultadosPdf',
      //   text: 'PDF',
      // },
    {
      key: 'ExportarListaResultadosShapeFile',
      text: 'Shapefile',
    },
  ]
  
  let _pdfExport: any;
  const exportExcel = () => {
    _export.save();
  };

  const onItemClickExportar = async (event: any) => {
    if (event.item.key == 'ExportarListaResultadosExcel') {
      exportExcel();
    }
    else if (event.item.key == "ExportarListaResultadosShapeFile") {
      const results = JSON.parse(
        SessionStorageService.getItem('resultadoApoioGestaoDesconformidade') ?? ''
      )
  
      if (results) {
        const ids: number[] = []
        results.forEach((element: any) => {
          ids.push(element.id)
        })

        const file: any = await getShapeFile(ids);
        const filePath = 'shapeFileAgDesconformidade.zip';

        handleDownload(file, filePath);
    }
  } 

  if(event.item.key == "ExportarListaResultadosPdf"){
    exportPDF();
  }
}


  let _export: any;
  const exportPDF = () => {
    _pdfExport.save();
  };

  const openPdfNewTab = () => {
    return new Promise<void>((resolve, reject) => {
        
        postMessage({ type: "showLoader" }, "*");

        setTimeout(() => {
           const columnsToShow = colums.columns.filter((x: { show: any }) => x.show);
           const dataToExport = desconformidades?.map((item: any) => {
            const filteredItem: any = {};
            columnsToShow.forEach((column: any) => {
                if (column.field.indexOf(".") != -1) {
                  const textArr = column.field.split(".");
                  const fieldString = textArr[0];
                  const valueString = textArr[1];
                  if (valueString) {
                    filteredItem[column.field] = item[fieldString][valueString];
                  }
                } else {
                filteredItem[column.field] = item[column.field];
              }
            });
            return filteredItem;
            });
            
            exportPDFWithMethod(columnsToShow, dataToExport, 8)
                .then((pdfData: any) => {
                    postMessage({ type: "hideLoader" }, "*");

                        const base64Data = pdfData.split(";base64,")[1];
                        console.log(base64Data);
                        const blob = b64toBlob(base64Data, 'application/pdf');
                        const blobUrl = URL.createObjectURL(blob);

                      
                        window.open(blobUrl, '_blank');
                        resolve();
                  
                })
                .catch(error => {
                    console.error('Error exporting PDF:', error);
                    reject(error);
                });
        }, 1000);
    });
};

  const onItemClickImprimir = async (event: any) => {
    openPdfNewTab();
  }


  const [dataResultDocumentos, setDataResultDocumentos] = useState(
    process(documentos, dataStateDocumentos)
  );

  const dataStateChangeDocumentos = (event: any) => {
    setDataResultDocumentos(process(documentos, event.dataState));
    setDataStateDocumentos(event.dataState);
  };

  const onItemClickImprimirDocumentos = (event: any) => {

    const link: HTMLAnchorElement | null = document.querySelector('#print-results-documentos');

    if (link) {
      link.click();
    }

    // if (event.item.key == 'ExportarListaResultados') {

      

    // }

  };

  const [columsDocuments, setColumsDocuments] = useState<{ columns: { field: string, title: string, width: number | string, show: boolean }[] }>({
    columns: [
      { field: "id", width: 70, title: "ID", show: true },
      { field: "desconformidade_id", width: 190 , title: "ID Desconformidade", show: true },
      { field: "dataPublicacaoFormatted", width: 190, title: "Data publicação", show: true },
      { field: "tipoRecurso.designacao", width: 190, title: "Tipo de recurso", show: true },
      { field: "titulo", width: 170, title: "Título", show: true },
      { field: "autores", width: 180, title: "Autor", show: true },
      { field: "entidade.nome", width: 180, title: "Entidade", show: true },
      { field: "primarioDescription", width: 180, title: "Primário", show: true },
    ]
  })

  const columnsInicio = {
    columns:[
      { field: "id", title: "ID", show: true, width: 70 },
      { field: "ag_tema.descricao", title: "Tema", show: true ,width: 190},
      { field: "descricao", title: "Descrição", show: true,width: 200 },
      { field: "concelhos", title: "Concelho", show: true, width: 190 },
      { field: "ag_estado.descricao", title: "Estado", show: true,width: 170 },
      { field: "decisao", title: "Decisão", show: true ,width: 190},
      { field: "medida_corretiva_aplicada", title: "Medida corretiva aplicada", show: true ,width: 240},
      { field: "medida_corretiva_a_aplicar", title: "Medida corretiva a aplicar", show: false ,width: 240},
      { field: "distritos", title: "Distrito", show: false, width: 190 },
      { field: "freguesias", title: "Freguesia", show: false, width: 190 },
      { field: "massasAgua", title: "Massa de água", show: false, width: 190 },
      { field: "arhs", title: "ARH", show: false, width: 190 },
      { field: "capitanias", title: "Capitania", show: false, width: 190 },
      { field: "nuts1", title: "NUTS I", show: false, width: 190 },
      { field: "nuts2", title: "NUTS II", show: false, width: 190 },
      { field: "nuts3", title: "NUTS III", show: false, width: 190 },
    ]
  }

  const columnsOrdered = {columns: columnsInicio.columns.slice().sort((a: any, b: any) => a.title.localeCompare(b.title))} 

  const [colums, setColums] =  useState<any>(() => {
    const storedValue = SessionStorageService.getItem('columnsAgDesconformidade');
    return storedValue ?? columnsOrdered;
  });

  const [columsGrid, setColumsGrid] =  useState<any>(() => {
    const storedValue = SessionStorageService.getItem('columnsAgDesconformidadeGrid');
    return storedValue ?? columnsInicio;
  });

  useEffect(() => {
    SessionStorageService.setItem("columnsAgDesconformidade", colums);
    updateColumnsGrid(colums, columsGrid, setColumsGrid);
  }, [colums])

  useEffect(()  => {
    SessionStorageService.setItem("columnsAgDesconformidadeGrid", columsGrid)
  }, [columsGrid])
  

  useEffect(() => {

    const iframe: any = document.getElementById('iframeGeoPortal')
    iframe.contentWindow?.postMessage(
      { type: 'SiarlDefineExtraLayerTooltipColumns', value:{  layer: AG_DESCONFORMIDADE_POINT_NAME,  columns: colums.columns.filter((x: { show: any }) => x.show).map((option: { field: any; title: any }) => ({
    field: option.field,
    title: option.title
  })) } },
      '*'
    )
  }, [colums]);
  
  const documentosToPreview = documentos

  const handleDocumentPreviewClickById = (documentosLocal: Record<string, any>) => async () => {

    try {
  
      postMessage({ type: "showLoader" }, "*");
      const documentos = await getDocumento(documentosLocal.id);
  
      setIdDoDocumento(documentosLocal.id);
      setUrlDoDocumento(documentos.url);
      setOpenForm(true);
  
    } catch (error) {
  
      handleGenericError(error, "Não foi possivel abrir o documento!")
      setOpenForm(false);
  
    } finally {
  
      postMessage({ type: "hideLoader" }, "*");
  
    }
  }
  
  const nextPhoto = async (e: any) => {
  
    try{
  
      postMessage({ type: "showLoader" }, "*");
      const nextIds = documentosToPreview
        .filter((doc: any) => doc.id < idDoDocumento && doc.url !== '')
        .map((doc: any) => doc.id);
  
      if (nextIds.length > 0) {
        const nextId = Math.max(...nextIds);
        console.log(`O próximo ID é ${nextId}`);
  
        const documento = await getDocumento(nextId);
  
        setIdDoDocumento(nextId.toString());
        setUrlDoDocumento(documento.url);
  
        const iframe: any = document.getElementById('iframeGeoPortal')
        const desconformidade_id = e.desconformidade_id;
        iframe.contentWindow?.postMessage(
          {
            type: 'SiarlDesconformidadeCenter',
            value: [desconformidade_id],
          },
          '*'
        )
  
      } else {
        console.log("Não há um próximo ID na lista.");
      }
  
    }catch(error){
  
      postMessage({ type: "errorMsg", value: "Não foi possivel abrir o documento!" }, "*");
  
    }finally{
  
      postMessage({ type: "hideLoader" }, "*");
  
      e.preventDefault();
    }
   
  }
  
  const previousPhoto = async (e: any) => {
  
    try{
  
      postMessage({ type: "showLoader" }, "*");
      const previousIds = documentosToPreview
        .filter((doc: any) => doc.id > idDoDocumento && doc.url !== '')
        .map((doc: any) => doc.id);
  
      if (previousIds.length > 0) {
        const previousId = Math.min(...previousIds);
        console.log(`O anterior ID é ${previousId}`);
  
        const documento = await getDocumento(previousId);
  
        setIdDoDocumento(previousId.toString());
        setUrlDoDocumento(documento.url);
  
        const iframe: any = document.getElementById('iframeGeoPortal')
        const desconformidade_id = e.desconformidade_id;
        iframe.contentWindow?.postMessage(
          {
            type: 'SiarlDesconformidadeCenter',
            value: [desconformidade_id],
          },
          '*'
        )
      } else {
        console.log("Não há um anterior ID na lista.");
      }
  
    } catch(error){
  
      handleGenericError(error, "Não foi possivel abrir o documento!")
  
    }finally{
  
      postMessage({ type: "hideLoader" }, "*");
  
      e.preventDefault();
    }
       
  }

  useLayoutEffect(() => {

    const handleResize = () => {

      if (window.innerWidth <= telaMobile) {
        
        setIsMobile(true);
        ocultaFloatingMenu_e_Mapa();

      }else{

        setIsMobile(false);
        mostraFloatingMenu_e_Mapa();

      }

    };
  
    window.addEventListener('resize', handleResize);
  
    handleResize();
  
    return () => {
      window.removeEventListener('resize', handleResize);
    };

  }, []);  


  const onItemClickMais = (event: any) => {

    elementoClickMais(event);

    onItemClickExportar(event);

    onItemClickImprimir(event);
  };

  const optionsMais = [
    {
      key: 'titulo',
      text: 'Exportar',
    },
    ...optionsExportar.map(option => ({
      ...option,
      className: 'icon-siarl icon-exportar btnIconRegistar',
    })),
  ]

  const documentsCustomCell = (props: GridCellProps) => (
    <ResultadoDocumentoCommandGridCell
    onLocationMouseEnter={function (documentos: Record<string, unknown>): void {
      console.log("n/a");
    } } onLocationMouseLeave={function (documentos: Record<string, unknown>): void {
      console.log("n/a");
    } } onLocationClick={mapCenter} onDocumentPreviewClick={handleDocumentPreviewClickById} {...props}
    onInfoClick={handleInfoClickById}    />
  )
  

  const registarNovoClick = () => {
    setDesconformidadeSelected(undefined);
    selectAgDesconformidadeResult(undefined);
    selectAgDesconformidadeResultId(undefined);
    SessionStorageService.setItem("novaDesconformidade", 'true');
    postMessage({ type: "form", value: "registarApoioGestaoDesconformidade" }, "*");
  }

  const openAjuda = () => {
    window.open(URL_AJUDA_APOIO_GESTAO_PRETENSAO, "_blank");
  }

    
  const PageTemplate = (props: any) => (
    <div className="page-template">
       <div className="header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '10px', padding: '10px' }}>
      
       <div>
       <img style={{ width: '128px', height: 'auto', marginLeft: '2px' }} src={base64SiarlImage} alt="SIARL Logo" />
       </div>
       <div style={{ textAlign: 'right' }}>
         <span style={{ fontSize: '18px', color: '#1ba49c' }}>PESQUISA DE DESCONFORMIDADES</span>
       </div>
     </div>
     <div className="footer" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '10px' }}>
        
       <div style={{ display: 'flex', gap: '20px', alignItems: 'center' }}>
         <img style={{ width: '105px', marginBottom: '-25px' }} src={base64ApaImage} alt="APA Logo" />
         <img style={{ width: '280px', height: 'auto', marginBottom: '-25px' }} src={base64FooterImages} alt="Footer Image" />
       </div>
      
       <div style={{ flex: 1, textAlign: 'right', marginBottom: '-25px' }}>
        Data : {format(new Date(), "dd/MM/yyyy")} | Página {props.pageNum} de {props.totalPages}
       </div>
     </div>
   </div>
 );

return (
  <>
    <div className={clsx(styles.base, isCurrentViewMaximized && commonStyles.maximizedBaseForm)}>
      <div className={styles.header}>
        <div>
          <div className={styles.nomeDoModulo}>Apoio à Gestão</div>
          <div className={styles.tituloDaPagina}>Resultados de pesquisa</div>
        </div>

        <div>

        { (hasPermission(PERMISSION_APOIO_GESTAOPERFIL_INTERMEDIO_EDICAO)) ||
          (hasPermission(PERMISSION_APOIO_GESTAO_PERFIL_TOTAL)) ||
          (hasPermission(PERMISSION_APOIO_GESTAO_PERFIL_COMPLETO_EDICAO))
          ?
          <Button
            onClick={registarNovoClick}
            className={styles.btnNovoRegisto}
            style={{ display: isMobile ? 'none' : '' }}
            id='novoRegisto'
            title='Nova Desconformidade'
          >
            <span className="icon-siarl icon-registar btnIconRegistar"></span>{' '}
            &nbsp;{' '}
            Nova Desconformidade
          </Button>
        : ''}

          <CSVLink
            title="Imprimir resultados"
            id="print-results-pretensoes"
            separator={';'}
            data={desconformidades.map((desconformidade: any) => ({
              ...desconformidade,
              data_registo: format(
                new Date(desconformidade?.data_registo),
                'dd/MM/yyyHHmm'
              ),
            }))}
            filename={`siarl-pretensoes-${format(
              new Date(),
              'ddMMyyyHHmm'
            )}`}
            hidden
          ></CSVLink>

          {!isMobile && showExportButtons &&
          <VisualizadorColunas 
              columns={selected===0?colums:columsDocuments} 
              setColumns={selected===0?setColums:setColumsDocuments}
              styles={styles.btnEditar2} 
           />
          }

          {showExportButtons ? 
        <button className={styles.btnEditar2} onClick={exportPDF} style={{ display: isMobile ? 'none' : '' }} id='imprimirFicha' title='Imprimir'>
          <span className="icon-siarl icon-imprimir"></span>
        </button>
        : ''}
          {!isMobile && showExportButtons &&
          <DropDownButton
          items={optionsExportar}
          className={styles.btnImprimir}
          style={{marginTop: '-4px'}}
          iconClass="icon-siarl icon-exportar"
          onItemClick={onItemClickExportar}
          fillMode={'flat'}
          title='Exportar'
          itemRender={itemRender}
        ></DropDownButton>
          }

          {isMobile && showExportButtons &&
            <DropDownButton
              items={optionsMais}
              className={styles.btnMais}
              iconClass="icon-siarl icon-mais"
              onItemClick={onItemClickMais}
              fillMode={'flat'}
              itemRender={itemRenderMais}
              title="Mais Opções"
            />
          }

          <button onClick={openAjuda} className={styles.btnInfo} title="Obter Ajuda">
            <span className="icon-siarl icon-ajuda"></span>
          </button>
          <button onClick={onCloseClick} className={styles.btnFechar} title="Minimizar">
            <span className="icon-siarl icon-minimizar"></span>
          </button>

          {!isMobile &&
          <MaximizeButton className={styles.btnMaximizar} />
          }
        </div>
      </div>
      <TabStrip selected={selected} onSelect={handleSelect} scrollable={isMobile}>
        <TabStripTab title="Desconformidades" key={'Desconformidades'}>
          <ExcelExport
            fileName='Resultado_Desconformidade'
            data={desconformidades.map((desconformidade: any) => ({
              ...desconformidade,
              data_registo: format(
                new Date(desconformidade.data_registo),
                'dd/MM/yyyHHmm'
              ),
            }))}
            ref={(exporter) => {
              _export = exporter
            }}
          >
            <Grid
              className={styles.form}
              sortable={true}
              onDataStateChange={dataStateChange}
              data={
                dataResult.data.length > 0 
                ? dataResult
                 :desconformidades
                }
              {...dataState}
              pageable={{
                buttonCount: 5,
                info: true,
                type: 'numeric',
                pageSizes: true,
                previousNext: true,
              }}
              total={desconformidades.length}
              //groupable={true}
            >
              <GridColumn cell={CommandCell} width={56} />

              {columsGrid?.columns?.map((column: { show: any; field: string | undefined; width: string | number | undefined; title: string | undefined }, i: any | undefined) => {
            return (
              column.show && (
                <GridColumn key={i}  field={column.field} width={column.width} title={column.title} />
              )
            );
          })}

              
            </Grid>
          </ExcelExport>
          <GridPDFExport
            fileName='Resultado_Desconformidade'
            ref={(element) => {
              _pdfExport = element
            }}
            paperSize="A4"
            margin={{ top: '3cm', right: '1cm', bottom: '2cm', left: '1cm' }}
            landscape={true}
            pageTemplate={PageTemplate} 
            repeatHeaders={true}
          >
              {
              <Grid
                sortable={true}
                 data={desconformidades}                
                  pageable={{
                  buttonCount: 5,
                  info: true,
                  type: 'numeric',
                  pageSizes: true,
                  previousNext: true,
                }}
                style={{ borderSpacing: '0' }} 
                //groupable={true}
              >
                {columsGrid?.columns?.map((column: any, i: any) => {
            return (
              column.show && (
                <GridColumn key={i}  field={column.field} filter={column.filter} width={column.width} title={column.title} columnMenu={column.columnMenu}
                headerCell={() => <div className="pdf-header">{column.title}</div>}
                cell={(props: any) => (
                  <td style={{ fontSize: '10px', wordBreak: 'break-word', padding: '5px', border: '1px solid #1ba49c' , lineHeight: '1.3' }}>
                    {props.dataItem[column.field]}
                  </td>
                )}
                />
              )
            );
          })}
              </Grid>
            }
          </GridPDFExport>
        </TabStripTab>

        <TabStripTab title="Documentos" key={'Documentos'}>
          <ExcelExport
            fileName='Resultado_Documento_Desconformidade'
            data={documentos}
            ref={(exporter) => {
              _export = exporter
            }}
          >
            <Grid
              className={styles.form}
              sortable={true}
              onDataStateChange={dataStateChangeDocumentos}
              data={
                dataResultDocumentos.data.length > 0
                  ? dataResultDocumentos
                  : documentos
              }
              {...dataState}
              pageable={{
                buttonCount: 5,
                info: true,
                type: 'numeric',
                pageSizes: true,
                previousNext: true,
              }}
              //groupable={true}
            >
              <GridColumn cell={documentsCustomCell} width={86} />
             {columsDocuments?.columns?.map((column, i) => {
            return (
              column.show && (
                <GridColumn key={i}  field={column.field} width={column.width} title={column.title} />
              )
            );
          })}
            </Grid>
          </ExcelExport>

          <GridPDFExport
            fileName='Resultado_Documentos_Desconformidade'
            ref={(element) => {
              _pdfExport = element
            }}
            margin="1cm"
          >
            <Grid
              className={styles.form}
              sortable={true}
              onDataStateChange={dataStateChangeDocumentos}
              data={
                dataResultDocumentos.data.length > 0
                  ? dataResultDocumentos
                  : documentos
              }
              {...dataState}
              pageable={{
                buttonCount: 5,
                info: true,
                type: 'numeric',
                pageSizes: true,
                previousNext: true,
              }}
              //groupable={true}
            >
              <GridColumn cell={documentsCustomCell} width={86} />
              {columsDocuments?.columns?.map((column, i) => {
            return (
              column.show && (
                <GridColumn key={i}  field={column.field} width={column.width} title={column.title} />
              )
            );
          })}
            </Grid>
          </GridPDFExport>
        </TabStripTab>
      </TabStrip>

      <div
        className={clsx(styles.footer, styles.justify_one_child, isCurrentViewMaximized && commonStyles.maximizedFooter)}
      >
        <Button className={styles.btnPesquisar} onClick={clearSearchResults} title='Nova Pesquisa'>
          <span className="icon-siarl icon-pesquisar btnIconPesquisar"></span>
          <span className={styles.rotulo}>
            {' '}&nbsp;{' '}
            Nova Pesquisa
          </span>
        </Button>
      </div>
    </div>
    {openForm && (
        <Dialog
        className="ModalDocumentos"
          title={`Documento: ${idDoDocumento}`}
          onClose={() => setOpenForm(false)}
          style={{ zIndex: 999 }}
        >
          
            <ImagePreviewV2
              documentUrl={urlDoDocumento}
              next={(e: any) => nextPhoto(e)}
              previous={(e: any) => previousPhoto(e)}
            />

        </Dialog>
      )}
  </>
)
}